(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["archive-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('archive-product-details')) {
  customElements.define('archive-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced === 'true') return;
      const enhance = () => {
        const description = this.querySelector('.a78-product-description');
        if (!description) return false;
        const sections = [...description.querySelectorAll(':scope > .a78-section')];
        if (sections.length < 2) return false;
        this.dataset.enhanced = 'true';
        sections.slice(1).forEach(section => {
          const headings = [...section.querySelectorAll(':scope > h4')];
          headings.forEach(heading => {
            const details = document.createElement('details');
            details.className = 'a78-detail';
            const summary = document.createElement('summary');
            summary.textContent = heading.textContent;
            const content = document.createElement('div');
            content.className = 'a78-detail__content';
            let next = heading.nextSibling;
            while (next && !(next.nodeType === 1 && next.tagName === 'H4')) {
              const current = next;
              next = next.nextSibling;
              content.append(current);
            }
            details.append(summary, content);
            heading.replaceWith(details);
          });
        });
        description.querySelectorAll(':scope > .a78-divider').forEach(divider => divider.remove());
        return true;
      };
      if (!enhance() && document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', enhance, {once: true});
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
